export default "__VITE_ASSET__XIDr4w1a__"